import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeCopyDTO  {
    _originalTypeClassName = "zERP.BO.EmployeeCopyDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeCopyDTO.translate = translateService;
}
this.Id = null;
this.FirstName = null;
this.LastName = null;
this.FatherName = null;
this.FatherSurname = null;
this.MotherName = null;
this.MotherSurname = null;
this.Fullname = null;
this.DateOfBirth = null;
this.PlaceOfBirth = null;
this.Gender = null;
this.FamilyStatus = null;
this.SpouseName = null;
this.ChildrenCount = null;
this.PhoneNumber = null;
this.MobilePhoneNumber = null;
this.Email = null;
this.DocumentType = null;
this.DocumentId = null;
this.DocumentAuthority = null;
this.DocumentIssueDate = null;
this.DocumentExpirationDate = null;
this.PassportId = null;
this.IBAN = null;
this.TaxNumber = null;
this.SocialSecurityNumber = null;
this.SocialRegistryNumber = null;
this.SecondarySocialRegistryNumber = null;
this.FirstInsuranceDate = null;
this.UnemploymentCardNumber = null;
this.HasUnemploymentBenefit = false;
this.NewlyInsured = false;
this.MilitaryObligations = null;
this.DeferralExpires = null;
this.ExternalID = null;
this.WorkPermitNumber = null;
this.WorkPermitFrom = null;
this.WorkPermitTo = null;
this.EmailBusiness = null;
this.AccountNumber = null;
this.AccountHolder = null;
this.BusinessPhone = null;
this.InternalPhone = null;
this.HasContract = false;
this.DocumentTypePhoto = null;
this.DocumentDescription = null;
this.DocumentPath = null;
this.PersonalNumber = null;
this.WorkPermitCountry = null;
this.DocumentIssueCountry = null;
this.Citizenship = null;
this.Nationality = null;
this.Bank = null;
this.TaxOffice = null;
this.Address = null;
this.Photo = null;
this.UserAccount = null;
this.WorkExperienceAnalysis = null;
this.DayOffExperienceAnalysis = null;
this.CTExperienceAnalysis = null;
this.GroupEmployee = null;
this.Ergani_Nationality = null;
this.Ergani_Taytotita = null;
this.Ergani_DOY = null;
this.Ergani_DimotikiEnotita = null;
this.ErganiForeignFile = null;
this.ErganiYoungFile = null;
this.Allowance = null;
this.EmploymentOffice = null;
this.Certification = null;
this.EducationalQualifications = null;
this.PastWorkExpirience = null;
this.EmergencyContacts = null;
this.Documents = null;
this.DepedentMember = null;
this.ForeignLanguange = null;
this.Payments = null;
this.Contracts = null;
this.MeetingToAttend = null;
this.VocationalEducation = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
FirstName:any;
LastName:any;
FatherName:any;
FatherSurname:any;
MotherName:any;
MotherSurname:any;
Fullname:any;
DateOfBirth:any;
PlaceOfBirth:any;
Gender:any;
FamilyStatus:any;
SpouseName:any;
ChildrenCount:any;
PhoneNumber:any;
MobilePhoneNumber:any;
Email:any;
DocumentType:any;
DocumentId:any;
DocumentAuthority:any;
DocumentIssueDate:any;
DocumentExpirationDate:any;
PassportId:any;
IBAN:any;
TaxNumber:any;
SocialSecurityNumber:any;
SocialRegistryNumber:any;
SecondarySocialRegistryNumber:any;
FirstInsuranceDate:any;
UnemploymentCardNumber:any;
HasUnemploymentBenefit:any;
NewlyInsured:any;
MilitaryObligations:any;
DeferralExpires:any;
ExternalID:any;
WorkPermitNumber:any;
WorkPermitFrom:any;
WorkPermitTo:any;
EmailBusiness:any;
AccountNumber:any;
AccountHolder:any;
BusinessPhone:any;
InternalPhone:any;
HasContract:any;
DocumentTypePhoto:any;
DocumentDescription:any;
DocumentPath:any;
PersonalNumber:any;
WorkPermitCountry:any;
DocumentIssueCountry:any;
Citizenship:any;
Nationality:any;
Bank:any;
TaxOffice:any;
Address:any;
Photo:any;
UserAccount:any;
WorkExperienceAnalysis:any;
DayOffExperienceAnalysis:any;
CTExperienceAnalysis:any;
GroupEmployee:any;
Ergani_Nationality:any;
Ergani_Taytotita:any;
Ergani_DOY:any;
Ergani_DimotikiEnotita:any;
ErganiForeignFile:any;
ErganiYoungFile:any;
Allowance:any;
EmploymentOffice:any;
Certification:any;
EducationalQualifications:any;
PastWorkExpirience:any;
EmergencyContacts:any;
Documents:any;
DepedentMember:any;
ForeignLanguange:any;
Payments:any;
Contracts:any;
MeetingToAttend:any;
VocationalEducation:any;

static assignPreviousEmployee($this: any, emp: any): any{let temp = [];
$this.FirstName = emp?.FirstName;
$this.LastName = emp?.LastName;
$this.FatherName = emp?.FatherName;
$this.FatherSurname = emp?.FatherSurname;
$this.MotherName = emp?.MotherName;
$this.MotherSurname = emp?.MotherSurname;
$this.Fullname = emp?.Fullname;
$this.DateOfBirth = emp?.DateOfBirth;
$this.PlaceOfBirth = emp?.PlaceOfBirth;
$this.Gender = emp?.Gender;
$this.FamilyStatus = emp?.FamilyStatus;
$this.SpouseName = emp?.SpouseName;
$this.ChildrenCount = emp?.ChildrenCount;
$this.PhoneNumber = emp?.PhoneNumber;
$this.MobilePhoneNumber = emp?.MobilePhoneNumber;
$this.Email = emp?.Email;
$this.DocumentType = emp?.DocumentType;
$this.DocumentId = emp?.DocumentId;
$this.DocumentAuthority = emp?.DocumentAuthority;
$this.DocumentIssueDate = emp?.DocumentIssueDate;
$this.DocumentExpirationDate = emp?.DocumentExpirationDate;
$this.PassportId = emp?.PassportId;
$this.IBAN = emp?.IBAN;
$this.TaxNumber = emp?.TaxNumber;
$this.SocialSecurityNumber = emp?.SocialSecurityNumber;
$this.SocialRegistryNumber = emp?.SocialRegistryNumber;
$this.SecondarySocialRegistryNumber = emp?.SecondarySocialRegistryNumber;
$this.FirstInsuranceDate = emp?.FirstInsuranceDate;
$this.UnemploymentCardNumber = emp?.UnemploymentCardNumber;
$this.HasUnemploymentBenefit = emp?.HasUnemploymentBenefit;
$this.NewlyInsured = emp?.NewlyInsured;
$this.MilitaryObligations = emp?.MilitaryObligations;
$this.DeferralExpires = emp?.DeferralExpires;
$this.ExternalID = emp?.ExternalID;
$this.WorkPermitNumber = emp?.WorkPermitNumber;
$this.WorkPermitFrom = emp?.WorkPermitFrom;
$this.WorkPermitTo = emp?.WorkPermitTo;
$this.EmailBusiness = emp?.EmailBusiness;
$this.AccountNumber = emp?.AccountNumber;
$this.AccountHolder = emp?.AccountHolder;
$this.BusinessPhone = emp?.BusinessPhone;
$this.InternalPhone = emp?.InternalPhone;
$this.HasContract = emp?.HasContract;
$this.DocumentTypePhoto = emp?.DocumentTypePhoto;
$this.DocumentDescription = emp?.DocumentDescription;
$this.DocumentPath = emp?.DocumentPath;
$this.PersonalNumber = emp?.PersonalNumber;
$this.WorkPermitCountry = emp?.WorkPermitCountry?.Id;
$this.DocumentIssueCountry = emp?.DocumentIssueCountry?.Id;
$this.Citizenship = emp?.Citizenship?.Id;
$this.Nationality = emp?.Nationality?.Id;
$this.Bank = emp?.Bank?.Id;
$this.TaxOffice = emp?.TaxOffice?.Id;
$this.Address = emp?.Address?.Id;
$this.Photo = emp?.Photo?.Id;
$this.WorkExperienceAnalysis = emp?.WorkExperienceAnalysis?.Id;
$this.DayOffExperienceAnalysis = emp?.DayOffExperienceAnalysis?.Id;
$this.CTExperienceAnalysis = emp?.CTExperienceAnalysis?.Id;
$this.GroupEmployee = emp?.GroupEmployee?.Id;
$this.Ergani_Nationality = emp?.Ergani_Nationality?.Id;
$this.Ergani_Taytotita = emp?.Ergani_Taytotita?.Id;
$this.Ergani_DOY = emp?.Ergani_DOY?.Id;
$this.Ergani_DimotikiEnotita = emp?.Ergani_DimotikiEnotita?.Id;
$this.ErganiForeignFile = emp?.ErganiForeignFile?.Id;
$this.ErganiYoungFile = emp?.ErganiYoungFile?.Id;
$this.Allowance = emp?.Allowance?.Id;
$this.EmploymentOffice = emp?.EmploymentOffice?.Id;
for (let _iitem = 0; _iitem < (emp?.Certification == null ? 0 : emp?.Certification.length); _iitem++) {let item = emp?.Certification[_iitem];temp?.add(item?.Id?.toString());}
$this.Certification = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (emp?.EducationalQualifications == null ? 0 : emp?.EducationalQualifications.length); _iitem++) {let item = emp?.EducationalQualifications[_iitem];temp?.add(item?.Id?.toString());}
$this.EducationalQualifications = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (emp?.PastWorkExpirience == null ? 0 : emp?.PastWorkExpirience.length); _iitem++) {let item = emp?.PastWorkExpirience[_iitem];temp?.add(item?.Id?.toString());}
$this.PastWorkExpirience = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (emp?.EmergencyContacts == null ? 0 : emp?.EmergencyContacts.length); _iitem++) {let item = emp?.EmergencyContacts[_iitem];temp?.add(item?.Id?.toString());}
$this.EmergencyContacts = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (emp?.Documents == null ? 0 : emp?.Documents.length); _iitem++) {let item = emp?.Documents[_iitem];temp?.add(item?.Id?.toString());}
$this.Documents = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (emp?.DepedentMember == null ? 0 : emp?.DepedentMember.length); _iitem++) {let item = emp?.DepedentMember[_iitem];temp?.add(item?.Id?.toString());}
$this.DepedentMember = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (emp?.ForeignLanguange == null ? 0 : emp?.ForeignLanguange.length); _iitem++) {let item = emp?.ForeignLanguange[_iitem];temp?.add(item?.Id?.toString());}
$this.ForeignLanguange = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (emp?.Payments == null ? 0 : emp?.Payments.length); _iitem++) {let item = emp?.Payments[_iitem];temp?.add(item?.Id?.toString());}
$this.Payments = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (emp?.Contracts == null ? 0 : emp?.Contracts.length); _iitem++) {let item = emp?.Contracts[_iitem];temp?.add(item?.Id?.toString());}
$this.Contracts = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (emp?.MeetingToAttend == null ? 0 : emp?.MeetingToAttend.length); _iitem++) {let item = emp?.MeetingToAttend[_iitem];temp?.add(item?.Id?.toString());}
$this.MeetingToAttend = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
for (let _iitem = 0; _iitem < (emp?.VocationalEducation == null ? 0 : emp?.VocationalEducation.length); _iitem++) {let item = emp?.VocationalEducation[_iitem];temp?.add(item?.Id?.toString());}
$this.VocationalEducation = CLMS.Framework.String.Join(", ", temp);
temp?.splice(0, temp.length);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}